let localTime = 0;
let serverTime = 0;

function getNow() {
    return new Date().getTime();
}

export function setTime(sTime?: number) {
    if(sTime){
        serverTime = sTime;
        localTime = getNow();
    }
}

export default function getTime() {
    if (serverTime && localTime) {
        const diff = getNow() - localTime;
        if (diff < 0) {
            return getNow();
        } else {
            return serverTime + diff;
        }
    } else {
        return getNow();
    }
}